import React from 'react';

const CasTable = ({casOrganizations}) => {
    return  <table className={'cas-container'}>
        <thead>
        <tr className='parent-row'>
            <th className='full-size-col'>CAS</th>
        </tr>
        </thead>
        <tbody>

        {casOrganizations.map((cas, index) => {
            return (
                <tr className={`parent-row ${casOrganizations.length === index + 1 ? 'last-parent' : ''}`} key={cas.casId}>
                    <td className={'full-size-col'}>
                        {cas.name}
                    </td>
                </tr>
            )
        })}

        </tbody>
    </table>

}

export default CasTable;
